import { createContext , useContext, useReducer} from "react";
import { initialState, Reducer } from "./Reducer";

const Context= createContext();

const Store = ({children}) =>{

    const [product, dis] =  useReducer(Reducer, initialState)
    return <Context.Provider value={{product, dis}}>
        {children}
    </Context.Provider>
}
export const Use_reduce_state =() =>useContext(Context);
export default Store;
